<ng-template #template>
  <div class="sg-base-dialog-container" [ngClass]="{ 'hide-input-labels': !dialogConfigData?.showInputLabels }">
    @if (!isEmptyDialog) {
    <div
      class="dialog-header"
      [ngStyle]="{'justify-content': !isEmptyDialog && !dialogConfigData?.withoutCloseBtn && !dialogConfigData?.dialogTitle ? 'flex-end' : 'flex-start'}">
      @if (dialogConfigData?.dialogTitle) {
      <div class="dialog-title" data-test="dialog-title">
        @if (dialogConfigData.titleIconName) {
        <mat-icon class="title-icon">{{ dialogConfigData.titleIconName }}</mat-icon>
        }
        <sg-text variant="sg-heading-medium-bold">{{ dialogConfigData.dialogTitle }}</sg-text>
      </div>
      }
      <ng-content select="#header-extra-info"></ng-content>
      <ng-content select="#buttons"></ng-content>
      @if (!dialogConfigData?.withoutCloseBtn) {
      <button class="dialog-top-btn" data-test="dialog-close-btn" mat-icon-button mat-dialog-close>
        <mat-icon>{{dialogConfigData?.closeDialogBtnIcon || 'sg-cancel-outlined'}}</mat-icon>
      </button>
      }
    </div>
    }
    <div class="dialog-body"><ng-content></ng-content></div>
  </div>
</ng-template>
